import React, { ReactNode } from 'react';
import FooterButtonGroup from 'components/footerButtonGroup/FooterButtonGroup';
import './ResultDisplay.scss';

export interface ResultDisplayProps {
  title: string;
  imageUrl: string;
  children: ReactNode;
  onCancel?: () => void;
  onNext?: () => void;
  cancelText?: string;
  nextText?: string;
  showFooter?: boolean;
  isNextDisabled?: boolean;
}

const ResultDisplay: React.FC<ResultDisplayProps> = ({
  title,
  imageUrl,
  children,
  onCancel,
  onNext,
  cancelText,
  nextText,
  showFooter = true,
  isNextDisabled,
}) => {
  return (
    <div className="result-display-container">
      <div className="result-display-content">
        <div className="result-display-section">
          {/* Title Section */}
          <div className="result-display-title">{title}</div>

          {/* Image Section */}
          <div className="result-display-image-wrapper">
            <img src={imageUrl} alt={title} className="result-display-image" />
          </div>

          {/* Details Section (children) */}
          <div className="result-display-details">{children}</div>
        </div>

        {/* Footer Button Group */}
        {showFooter && onNext && (
          <FooterButtonGroup
            onCancel={onCancel}
            onContinue={onNext}
            cancelText={cancelText}
            continueText={nextText}
            isContinueDisabled={isNextDisabled}
          />
        )}
      </div>
    </div>
  );
};

export default ResultDisplay;

